export default __webpack_public_path__ + "static/media/SndLowerUDownBump.2ace8587.mp3";